import type { SVGProps } from 'react';
import * as React from 'react';

const FlvIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={40} height={44} viewBox="0 0 40 44" fill="none" aria-hidden="true" {...props}>
    <g id="file-icon/flv">
      <g id="Vector" filter="url(#filter0_dd_3816_38171)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.2223 1L35.3334 10.1111V38.3333C35.3334 39.8061 34.1505 41 32.6777 41C27.0142 41 13.7443 41 7.32677 41C5.85401 41 4.66675 39.82 4.66675 38.3473C4.66675 30.3468 4.66675 10.7752 4.66675 3.6498C4.66675 2.17704 5.86066 1 7.33341 1H26.2223Z"
          fill="#3B82F6"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.2223 1L35.3334 10.1111V38.3333C35.3334 39.8061 34.1505 41 32.6777 41C27.0142 41 13.7443 41 7.32677 41C5.85401 41 4.66675 39.82 4.66675 38.3473C4.66675 30.3468 4.66675 10.7752 4.66675 3.6498C4.66675 2.17704 5.86066 1 7.33341 1H26.2223Z"
          fill="url(#paint0_radial_3816_38171)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.2223 1L26.2223 7.44444C26.2223 8.9172 27.4162 10.1111 28.889 10.1111L35.3334 10.1111L26.2223 1Z"
          fill="white"
          fillOpacity={0.3}
        />
      </g>
      <path
        id="Vector_2"
        d="M20.2281 15.4445C15.9332 15.4445 12.4443 18.9333 12.4443 23.2282C12.4443 27.5232 15.9332 31 20.2281 31C24.5231 31 27.9999 27.5232 27.9999 23.2282C27.9999 18.9333 24.511 15.4565 20.2281 15.4445ZM23.5005 23.4689C23.4403 23.5771 23.3561 23.6614 23.2478 23.7215L18.8085 25.9472C18.5318 26.0795 18.195 25.9712 18.0626 25.6945C18.0145 25.6223 18.0025 25.5381 18.0025 25.4419V21.0026C18.0025 20.6898 18.2551 20.4492 18.5559 20.4492C18.6401 20.4492 18.7243 20.4612 18.8085 20.5093L23.2478 22.723C23.5245 22.8673 23.6328 23.1922 23.5005 23.4689Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_dd_3816_38171"
        x={2.66675}
        y={0}
        width={34.6667}
        height={44}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={0.5} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3816_38171" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="effect1_dropShadow_3816_38171" result="effect2_dropShadow_3816_38171" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_3816_38171" result="shape" />
      </filter>
      <radialGradient
        id="paint0_radial_3816_38171"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(20.0001 0.999999) rotate(90) scale(40 40.1825)"
      >
        <stop offset={0.297418} stopOpacity={0} />
        <stop offset={1} stopOpacity={0.08} />
      </radialGradient>
    </defs>
  </svg>
);
export default FlvIcon;
